import _ from 'lodash';
import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import updateLocale from 'dayjs/plugin/updateLocale';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(updateLocale);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);

// const WEEKS_STANDARD_AMERICAN = 10;
// window.dayjs = dayjs;

const WEEKS_STANDARD_ISO8601 = 20;

class DateUtil {
  constructor() {
    this.format = 'YYYY-MM-DD HH:mm:ss';
    this.formatYMD = 'YYYY-MM-DD';
    this.offset = dayjs().utcOffset();
  }

  getWeekOfYearBeginEndDateString(year, week, weeksStandard) {
    if (_.isUndefined(year) || year === '') {
      return;
    }
    let startDay = null;
    let endDay = null;
    var day = dayjs().year(year).set('h', 0).set('m', 0).set('s', 0).set('ms', 0);
    this._setWeekStart(1);
    if (weeksStandard === WEEKS_STANDARD_ISO8601) {
      startDay = day.isoWeek(week).startOf('isoWeek').format(this.formatYMD);
      endDay = day.isoWeek(week).endOf('isoWeek').format(this.formatYMD);
    } else {
      startDay = day.week(week).startOf('week').format(this.formatYMD);
      endDay = day.week(week).endOf('week').format(this.formatYMD);
    }
    return [startDay, endDay];
  }

  // getStandardWeek(date) {
  //   this._setWeekStart(1);
  //   return dayjs(date).endOf('week').format('YYYY-MM-DD');
  //   return dayjs(date).endOf('isoWeek').format('YYYY-MM-DD');
  //   // dayjs().format('YYYY-MM-DD');
  // }

  // 甘特图中获取周数
  getStandardWeek(date) {
    this._setWeekStart(1);
    return dayjs(date).week();
  }

  // gantt获取欧洲周数
  getEuropeWeek(date) {
    return dayjs(date).isoWeek();
  }

  getWeekOfYear(date, weeksStandard) {
    // if (!_.isUndefined(weekStart)) {
    //   this._setWeekStart(weekStart);
    // } else {
    //   this._setWeekStart(0);
    // }
    if (_.isUndefined(date) || date === '') {
      return;
    }

    if (weeksStandard === WEEKS_STANDARD_ISO8601) {
      return dayjs(date).isoWeek();
    } else {
      return dayjs(date).week();
    }
  }

  // getWeekOfYearBeginEndDateString(year, week, weeksStandard) {
  //   if (_.isUndefined(year) || year === '') {
  //     return;
  //   }
  //   var day = dayjs().year(year).set('h', 0).set('m', 0).set('s', 0).set('ms', 0);
  //   if (weeksStandard === WEEKS_STANDARD_ISO8601) {
  //     day = day.isoWeek(week);
  //   } else {
  //     day = day.week(week);
  //   }
  //   // return [day.format(this.formatYMD), day.add(6, 'day').format(this.formatYMD)];
  //   return [day.add(-1, 'day').format(this.formatYMD), day.add(5, 'day').format(this.formatYMD)];
  // }

  getUtcOffsetMinutes() {
    return this.offset;
  }

  convertToTimeString(time) {
    return dayjs(time).format(this.format);
  }

  interceptingTime(time) {
    if (time) {
      return dayjs(time).format(this.formatYMD);
    } else {
      return '';
    };
  }

  convertToLocalTimeString(utcDate) {
    return dayjs(utcDate).add(this.offset, 'minute').format(this.format);
  }

  covertToUtclTimeString(localDate) {
    return dayjs(localDate).add(-this.offset, 'minute').format(this.format);
  }

  getUtcBeginEndTimeStringOfDay(localDate) {
    const beginDate = dayjs(localDate).set('h', 0).set('m', 0).set('s', 0).set('ms', 0);
    const endDate = dayjs(localDate).set('h', 23).set('m', 59).set('s', 59).set('ms', 999);
    return {
      beginTime: beginDate.add(-this.offset, 'minute').format(this.format),
      endTime: endDate.add(-this.offset, 'minute').format(this.format)
    };
  }

  getDaysTime(localDate, beginDate) {
    let date;
    if (beginDate) {
      date = dayjs(localDate).set('h', 0).set('m', 0).set('s', 0).set('ms', 0).format(this.format);
    } else {
      date = dayjs(localDate).set('h', 23).set('m', 59).set('s', 59).set('ms', 999).format(this.format);
    }
    return date;
  }

  addDays(localDate, addDay) {
    const date = dayjs(localDate).set('h', 0).set('m', 0).set('s', 0).set('ms', 0).add(addDay, 'day').format(this.formatYMD);
    return date;
  }

  getMonthDays(date, i) {
    const noOfDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (i !== 1) {
      return noOfDays[i];
    }
    // Feb
    const year = date.getFullYear();
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      return 29;
    }
    return 28;
  }

  _setWeekStart(weekStart) {
    if (!_.isInteger(weekStart) || weekStart < 0 || weekStart > 7) {
      throw new Error('Invalid Week Start,' + weekStart);
    }

    if (weekStart === 7) {
      // value of sunday is 7 in my erp system
      weekStart = 0;
    }
    dayjs.updateLocale('en', {
      weekStart
    });
  }
}
// window.DateUtil = new DateUtil();
export default new DateUtil();